import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { OverlayService } from 'src/app/services/overlay.service';
import { PushService } from 'src/app/services/push.service';

@Component({
  selector: 'app-pushmessages',
  templateUrl: './pushmessages.component.html',
  styleUrls: ['./pushmessages.component.scss']
})
export class PushmessagesComponent implements OnInit {
  /**
   * @ignore
   * Not needed atm => only Filter is sorting by Header
   */
  @ViewChild(MatSort) sort: MatSort;
  /**
   * The Form to filter the PushMessages
   */
  filterForm: UntypedFormGroup;
  /**
   * The data to be shown
   */
  dataSource: MatTableDataSource<any>;
  /**
   * THe Columns of the Table
   */
  displayedColumns = ['number', 'message', 'type', 'sendingOn', 'sendOn', 'menu'];
  /**
   * The Currentpage of PushMessages
   */
  page = null;
  /**
   * pagemetadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * The current SortOrder from the Table
   */
  currentSortOrder: string = "sendOn,desc";
  /**
   * The Types of PushMessage
   */
  sortOptionsState = [
    { value: "EVENTS", viewValue: "Aktion" },
    { value: "NEWS", viewValue: "Infobeitrag" },
    { value: "GARBAGE", viewValue: "Abfallkalender" }
  ]
  /**
   * constructor
   * Init the Form
   * @param pushService 
   * @param router 
   * @param route 
   * @param overlayService 
   * @param fb 
   */
  constructor(
    private pushService: PushService,
    private router: Router,
    private route: ActivatedRoute,
    private overlayService: OverlayService,
    private fb: UntypedFormBuilder) {
    this.filterForm = this.fb.group({
      searchTerm: [],
      filterByTypes: []
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })

    this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
      this.page = push.page
      push.content.forEach(element => {
        element["appLinkV2"] = element.appLink.slice(15);
      });
      this.dataSource = new MatTableDataSource(push.content);
      this.dataSource.sort = this.sort;
    });
  }
  /**
   * Look for change on the sort Headers
   */
  ngAfterViewInit() {
    this.sort.sortChange.subscribe(value => {
      this.currentSortOrder = value.active + "," + value.direction;
      this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, value.active + "," + value.direction, this.filterForm.value.searchTerm).subscribe((push: any) => {
        this.page = push.page
        push.content.forEach(element => {
          element["appLinkV2"] = element.appLink.slice(13);
        });
        this.dataSource = new MatTableDataSource(push.content);
      })
    });
  }
  /**
   * Load the Page of PushMessages
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * search for the PushMessages
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.pushService.filterPushMessages(pageIndex, pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
      this.page = push.page
      this.page = push.page
      push.content.forEach(element => {
        element["appLinkV2"] = element.appLink.slice(13);
      });
      this.dataSource = new MatTableDataSource(push.content);
    })
  }
  /**
   * Move to the Edit page
   * @param push 
   */
  openEditWithData(push) {
    let navigationExtras: NavigationExtras = {
      state: {
        push: push
      }
    };
    this.router.navigate(['caseworker/pushmessages/edit'], navigationExtras);
  }
  /**
   * duplicate the PushMessage
   * @param push 
   */
  duplicate(push) {
    this.pushService.duplicatePushMessage(push).subscribe(fromDuplicate => {
      if (fromDuplicate) {
        this.overlayService.openSnackBar("Push-Nachricht erfolgreich dupliziert!")
        this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element["appLinkV2"] = element.appLink.slice(13);
          });
          this.dataSource = new MatTableDataSource(push.content);
        })
      } else {
        this.overlayService.openSnackBar("Fehler beim duplizieren!")
      }
    })
  }
  /**
   * Delte the PushMessage
   * @param push 
   */
  delete(push) {
    this.pushService.deletePushMessage(push.publicId).subscribe(fromDelete => {
      if (fromDelete) {
        this.overlayService.openSnackBar("Push-Nachricht erfolgreich gelöscht!")
        this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element["appLinkV2"] = element.appLink.slice(13);
          });
          this.dataSource = new MatTableDataSource(push.content);
        })
      } else {
        this.overlayService.openSnackBar("Fehler beim löschen!")
      }
    })
  }
  /**
   * Sent the PushMessage now
   * @param push 
   */
  sentInstat(push) {
    this.pushService.sendInstantPushMessage(push).subscribe(fromSent => {
      if (fromSent) {
        this.overlayService.openSnackBar("Push-Nachricht erfolgreich gesendet!")
        this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element["appLinkV2"] = element.appLink.slice(13);
          });
          this.dataSource = new MatTableDataSource(push.content);
        })
      } else {
        this.overlayService.openSnackBar("Fehler beim senden!")
      }
    })
  }
  /**
   * Get the PushMessages based on the Filter
   */
  filterPushMessages() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByTypes: this.filterForm.value?.filterByTypes,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.pushService.filterPushMessages(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByTypes, this.currentSortOrder, this.filterForm.value.searchTerm).subscribe((push: any) => {
          this.page = push.page
          push.content.forEach(element => {
            element["appLinkV2"] = element.appLink.slice(13);
          });
          this.dataSource = new MatTableDataSource(push.content);
        })
      })
  }
  /**
   * Reset the Filter and load unfilterd Events
   */
  resetFilter() {
    this.filterForm.reset()
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByTypes: this.filterForm.value?.filterByTypes
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.filterPushMessages();
      })
  }

  /**
   * Filter the Events when Enter is pressed
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterPushMessages()
    }
  }
}